import React, { useState} from "react";
import "./Home.css";

function Home() {
  // fixed Header
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header");
    header.classList.toggle("active", window.scrollY > 0);
  });
  // Toogle Menu
   const [show, setShow] = useState("");
 
  return (
    <div className="home" id="Home">
      <div className="home__bg">
        <div className="header d__flex align__items__center pxy__30">
          {/* <div className="logo"> 
             <img src={logo} alt=""/> 
          </div> */}

          <div className="navigation pxy__30">
            <ul className="navbar d__flex">
              <a href="#Home">
                <li className="nav__items mx__15">Home</li>
              </a>
              <a href="#About">
                <li className="nav__items mx__15">About</li>
              </a>
              {/* <a href="#Services">
                <li className="nav__items mx__15">Services</li>
              </a> */}
              <a href="#Project">
                <li className="nav__items mx__15">Project</li>
              </a>
              <a href="#Experience">
                <li className="nav__items mx__15">Experience</li>
              </a>
              <a href="#Contact">
                <li className="nav__items mx__15">Contact</li>
              </a>
            </ul>
          </div>
          {/* Toogle Menu */}
          <div className="toggle__menu">
            <svg onClick={() => setShow(!show)}
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-justify white pointer"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M2 12.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </div>
          {show ?(
          <div className="sideNavbar">
              <ul className="sidebar d__flex">
              <li className="sideNavbar">
              <a href="#Home">Home</a>

            </li>
            <li className="sideNavbar">
              <a href="#About">About</a>
            </li>
            {/* <li className="sideNavbar">
              <a href="#services">Services</a>
            </li> */}
            <li className="sideNavbar">
            <a href="#Project">Project</a>
            </li>
            <li className="sideNavbar">
              <a href="#Experience">Experience</a>
            </li>
            <li className="sideNavbar">
              <a href="#Contact">Contact</a>
            </li>
              </ul>
          </div>
           ) : null}
        </div>
        {/* HOME CONTENT */}
        <div className="container">
          <div className="home__content">
            <div className="home__meta">
              <h3 className="home__text sweet pz__10" >I'm SanthoshKumar Duraisamy                  
               </h3> <br/>
              <h5 className="home__text pz__10">Fraud Analyst / Full Stack Developer</h5>
                <br/>
                <div className="about__button d__flex align__items__center">
                  <a href="#Contact">
                  <button className="about btn pointer">Contact Me</button>
                </a>
                </div>
                
              </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;

